import React from 'react';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useStyles } from '@wix/tpa-settings/react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useAdaptedSettings, useStylesParams } from '../../../../hooks';
import { alignmentName } from '../../../../utils/alignment';
import { st, classes } from './List.st.css';

interface HeaderProps {
  overrideAppTitle?: string;
  overrideAppSubtitle?: string;
  maxWidthStyle: React.CSSProperties;
}

export const Header: React.FC<HeaderProps> = ({ overrideAppTitle, overrideAppSubtitle, maxWidthStyle }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const stylesParams = useStylesParams();
  const settings = useAdaptedSettings();

  const showPageTitle = styles.get(stylesParams.showPageTitle) || Boolean(overrideAppTitle);
  const showPageSubtitle =
    styles.get(stylesParams.showPageSubtitle) || settings.get('showPageSubtitle') || Boolean(overrideAppSubtitle);

  if (!showPageTitle && !showPageSubtitle) {
    return null;
  }

  const TitleTag = settings.get('titleHtmlTag') as keyof React.JSX.IntrinsicElements;

  return (
    <div className={classes.header} style={maxWidthStyle}>
      {showPageTitle && (
        <TitleTag
          className={st(classes.title, { textAlignment: alignmentName(styles.get(stylesParams.titleAlignment)) })}
          data-hook="app-title"
        >
          {overrideAppTitle || settings.get('pageHeaderText') || t('pp.defaults.pageTitle')}
        </TitleTag>
      )}
      {showPageSubtitle && (
        <p
          className={st(classes.subtitle, {
            textAlignment: alignmentName(styles.get(stylesParams.subtitleAlignment)),
          })}
          data-hook={VIEWER_HOOKS.PP_WIDGET_SUBTITLE}
        >
          {overrideAppSubtitle || settings.get('pageSubtitleText') || t('pp.defaults.pageSubtitle')}
        </p>
      )}
    </div>
  );
};
